import { render, staticRenderFns } from "./SupportDetails.vue?vue&type=template&id=1e0d55dd&"
import script from "./SupportDetails.vue?vue&type=script&lang=js&"
export * from "./SupportDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupportDetails.vue?vue&type=style&index=0&id=1e0d55dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports